import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

import { ErrorPage, NotFoundPage } from "@/components/SystemPage";
import { CatalogFonts } from "@/lib/fonts";
import { SessionProvider } from "@/lib/session";
import { Outlet, createRootRouteWithContext, HeadContent } from "@tanstack/react-router";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  head: () => ({
    meta: [
      { title: "MonteBox — Configurador de Pedidos" },
      {
        name: "description",
        content:
          "Monte seu pedido do seu jeito: escolha os itens, visualize em tempo real e acompanhe o valor total.",
      },
      { property: "og:title", content: "MonteBox — Configurador de Pedidos" },
      {
        property: "og:description",
        content:
          "Monte seu pedido do seu jeito: escolha os itens, visualize em tempo real e acompanhe o valor total.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RootComponent,
  // Valem para o app inteiro: nenhum layout define as suas, então loja,
  // conta, painel e revenda caem nestas (com o caminho de volta certo).
  notFoundComponent: NotFoundPage,
  errorComponent: ErrorPage,
});

function RootComponent() {
  const { queryClient } = Route.useRouteContext();

  return (
    <QueryClientProvider client={queryClient}>
      {/* A sessao vive dentro do QueryClient: ao trocar de usuario ela limpa
          o cache, senao os dados do login anterior sobreviveriam ao logout. */}
      <SessionProvider>
        {/* Aplica no document.head as meta declaradas em head() por cada rota. */}
        <HeadContent />
        {/* Um Toaster para o app inteiro: toda tela precisa dizer se a acao
            deu certo, e dois Toasters mostrariam a mesma mensagem duas vezes. */}
        <Toaster richColors position="top-center" />
        {/* Fontes enviadas pelo painel: loja, painel e calibragem desenham os
            mesmos textos, então o registro é um só. */}
        <CatalogFonts />
        {/* Obrigatorio: as rotas filhas renderizam aqui. */}
        <Outlet />
      </SessionProvider>
    </QueryClientProvider>
  );
}
